<template>
  <div>
    <div class="title">
        <div>
            <van-icon v-if="form.Status === '已取消'" name="clear" color="#999999" size="20px"/>
            <van-icon v-else name="checked" color="#FEB013" size="20px"/>
            <a style="font-size:16px;font-weight:bold;padding-left:6px;">{{form.Status}}</a>
        </div>
        <div>{{form.DateTime}} </div>
    </div>
    <div class="card-box">
        <div class="card-title">
            <a class="card-title-text">拼车信息</a>
        </div>
        <div class="routebox">
            <div style="width: 30%;">
                <div class="start-icon">起</div>
                <div>{{form.Origin}}</div>
            </div>
            <div style="width: 30%;text-align: center;">
                <div class="center-text">{{form.DepartTime}}发车</div>
            </div>
            <div style="text-align: -webkit-right;width: 30%;">
                <div class="end-icon">终</div>
                <div>{{form.Destination}}</div>
            </div>
        </div>
        <div style="padding:8px 0 4px 0;font-size:14px;">途径  {{form.Way}}</div>
    </div>
    <div class="card-box">
        <div class="card-title">
            <a class="card-title-text">其他信息</a>
        </div>
        <div style="line-height: 1.5;font-size: 15px;margin-top: 8px;">
            <div class="cell">
                <a>司机姓名</a><a>{{form.Name}}</a>
            </div>
            <div class="cell">
                <a>车辆信息</a><a>{{form.CarName}}|{{form.CarSeat}}座</a>
            </div>
            <div class="cell">
                <a>车牌号吗</a><a>{{form.CarNum}}</a>
            </div>
        </div>
        <div style="display: flex;align-items: center;padding:8px 0;">
            <van-image width="20" height="20" :src="require('../../assets/img2.svg')"/>
            <div class="carperson">{{form.passenger && form.passenger.length>0?'同行'+form.passenger.length+'人':'无乘客信息' }}</div>
        </div>
        <div class="person-card" v-for="(item, key) in passengerList" :key="key">
            <div style="display: flex;justify-content: space-between;">
                <div>
                    <a style="padding-right:8px;">{{item.Name}}</a>
                    <template v-if="role === 'driver'">
                        <van-icon name="phone" size="14" color="#FEB013"/>
                        <a class="passenger-tel" :href="'tel://' + item.Phone">{{item.Phone}}</a>
                    </template>
                </div>
                <div>
                    <van-icon name="clock" color="#C9C9C9"/>
                    <a style="color:#999999;padding-left:4px;">{{$moment(item.CreateTime).format('HH:mm')}} {{item.Status}}</a>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            role: '',
            form: {},
            passengerList: []
        }
    },
    async mounted() {
        // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        this.role = this.$route.query.role
        await this.getTravelData()
        await this.getPassengerList()
    },
    methods: {
        async getTravelData() {
            const result = await this.$request({
                url: this.$api.getWorkTravel,
                method: 'GET',
                params: {
                    _id: this.$route.query.id
                }
            })
            if (result.data.length > 0) {
                this.form = result.data[0]
                // if (this.role === 'passenger') {
                //     this.form.Status = this.form.passengers.find(val => val.OpenId === this.WXInfo.openid).Status
                // }
            } else {
                this.$toast(result.message)
            }
        },
        async getPassengerList() {
            const result = await this.$request({
                url: this.$api.getWorkTravelFromPassenger,
                method: 'GET',
                params: {
                    ParentsId: this.$route.query.id
                }
            })
            if (result.data.length > 0) {
                this.passengerList = result.data
            }
        },
    }
}
</script>

<style scoped>
.title{
    padding:15px 16px;
    background-color:#FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card-box {
    background: #FFFFFF;
    border-radius:4px;
    margin:8px 12px;
    padding: 8px 12px;
}
.card-title {
    border-bottom:1px solid #D2D2D2;
    padding-bottom:8px;
}
.card-title-text {
    font-size:15px;
    padding-right:8px;
}
.routebox {
    font-size: 15px;
    font-weight: 600;
    padding: 8px 0;
    border-bottom:1px dashed #D2D2D2;
    display: flex;
    justify-content: space-between;
}
.start-icon {
    height: 22px;
    width: 22px;
    background-color: #39A0F4;
    color: #ffffff;
    border-radius: 50%;
    padding: 4px;
    text-align: center;
}
.center-text {
    border-bottom: 1px dashed #999999;
    margin-top: 25%;
    font-size: 14px;
    font-weight: initial;
}
.end-icon {
    height: 22px;
    width: 22px;
    background-color: #4DBE86;
    color: #ffffff;
    border-radius: 50%;
    padding: 4px;
    text-align: center;
}
.carperson {
    font-size: 12px;
    color: #F22222;
    padding-left: 4px;
}
.person-card {
    background-color: #F9F9F9;
    padding: 4px 12px;
    border-radius: 4px;
}
.passenger-tel {
    padding-left:4px;
    text-decoration: underline;
    color: black;
    font-size: 14px;
}
.cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
